export default __webpack_public_path__ + "static/media/login.60e6e9f8.png";